/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiUserActionConversionFromJSON, ApiUserActionConversionToJSON, } from './ApiUserActionConversion';
export function ApiUserActionPageViewFromJSON(json) {
    return ApiUserActionPageViewFromJSONTyped(json, false);
}
export function ApiUserActionPageViewFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'averageScrollSpeed': !exists(json, 'averageScrollSpeed') ? undefined : json['averageScrollSpeed'],
        'channel': !exists(json, 'channel') ? undefined : json['channel'],
        'conversions': !exists(json, 'conversions') ? undefined : (json['conversions'].map(ApiUserActionConversionFromJSON)),
        'displayPage': !exists(json, 'displayPage') ? undefined : json['displayPage'],
        'externalCampaign': !exists(json, 'externalCampaign') ? undefined : json['externalCampaign'],
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
        'isSessionEffective': !exists(json, 'isSessionEffective') ? undefined : json['isSessionEffective'],
        'locations': !exists(json, 'locations') ? undefined : json['locations'],
        'purchasedProductNames': !exists(json, 'purchasedProductNames') ? undefined : json['purchasedProductNames'],
        'revenue': !exists(json, 'revenue') ? undefined : json['revenue'],
        'scrolledPercentage': !exists(json, 'scrolledPercentage') ? undefined : json['scrolledPercentage'],
        'sessionAudiences': !exists(json, 'sessionAudiences') ? undefined : json['sessionAudiences'],
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'timeOnPageSeconds': !exists(json, 'timeOnPageSeconds') ? undefined : json['timeOnPageSeconds'],
        'viewedPercentage': !exists(json, 'viewedPercentage') ? undefined : json['viewedPercentage'],
    };
}
export function ApiUserActionPageViewToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'averageScrollSpeed': value.averageScrollSpeed,
        'channel': value.channel,
        'conversions': value.conversions === undefined ? undefined : (value.conversions.map(ApiUserActionConversionToJSON)),
        'displayPage': value.displayPage,
        'externalCampaign': value.externalCampaign,
        'isEffective': value.isEffective,
        'isSessionEffective': value.isSessionEffective,
        'locations': value.locations,
        'purchasedProductNames': value.purchasedProductNames,
        'revenue': value.revenue,
        'scrolledPercentage': value.scrolledPercentage,
        'sessionAudiences': value.sessionAudiences,
        'sessionId': value.sessionId,
        'source': value.source,
        'timeOnPageSeconds': value.timeOnPageSeconds,
        'viewedPercentage': value.viewedPercentage,
    };
}
